module.exports = __webpack_public_path__ + "img/xsz-just-bg.646cf695.png";